import { render } from "./CardUnidade.vue?vue&type=template&id=dba64bf4"
import script from "./CardUnidade.vue?vue&type=script&lang=js"
export * from "./CardUnidade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__